module.exports = __webpack_public_path__ + "static/media/blue-bubble-arrow.5d9c2c3c.svg";